import React,{useState} from 'react'
import {useForm} from 'react-hook-form'
import { toast } from "react-toastify";
import clinicService from '../../../../../services/clinic.service';

function LensList({lens,updateList,removeItem}) {
  const [loading, setLoading] = useState(false)
  const [edit,setEdit] = useState(false)
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues:lens
  })

  const onSubmit = (data)=>{
    clinicService.addUpdateLens(data.clinicId,data)
    .then(res=>{
        updateList(res.data)
        toast.success("Updated Contact Lens",{
            position:toast.POSITION.BOTTOM_RIGHT
        })
    })
    .catch(err=>{
        toast.error("Error While Updating Contact Lens",{
            position:toast.POSITION.BOTTOM_RIGHT
        })
    })
    
    setEdit(!edit)
  }

  const handleRemove = (lens)=>{
   
    clinicService.deleteLens(lens.clinicId,lens.id)
    .then(res=>{
        if(res.status === 200)
        {
            toast.success("Removed Brand",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
            removeItem(lens.id)
        }
    })
    .catch(err=>{
        toast.error("Error While Removing Brand",{
            postion:toast.POSITION.BOTTOM_RIGHT
        })
    })
  }
  return (
    <li className={"list-group-item list-group-item-action d-flex justify-content-between align-items-center"}>
        {!edit?<>
            <span>{lens.status ===1? "Active":"Inactive"} &nbsp;&nbsp;&nbsp;&nbsp; {lens.brandName}</span>
            <div>
            <button className="btn btn-sm btn-warning me-3" onClick={()=>setEdit(!edit)}>Edit</button>
            <button className="btn btn-sm btn-danger" onClick = {()=>handleRemove(lens)}>Delete</button>
        </div>
        </>:<>
            <form className="row" onSubmit= {handleSubmit(onSubmit)}>
                <div className="col-4">
                <select className='form-select form-select-sm me-2' {...register("status")}>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                </select>
                </div>
                <div className="col-4">
                <input className='form-control form-control-sm' {...register("brandName")} type="text"/>
                </div>
                <div className="col-4">
                    <button type="submit" className="btn btn-sm btn-primary">Save</button>
                </div>
               

            </form>
            <button className="btn btn-sm btn-secondary" onClick={()=>setEdit(!edit)}>Cancel</button>
        </>}
       
    </li>
  )
}

export default LensList